export default __webpack_public_path__ + "static/media/option_slide.0ba96596.png";